import { getCollection } from './firestoreService';
import { convertTimestamp } from './firestoreService';

export interface ActiveSession {
  id: string;
  userId: string;
  sessionId?: string;
  lastActivityAt?: Date;
  createdAt?: Date;
  deviceInfo?: Record<string, unknown>;
  isActive?: boolean;
}

export interface ActiveSessionsSummary {
  totalActiveSessions: number;
  sessions: ActiveSession[];
}

const SESSION_TIMEOUT_HOURS = 24;

export const getActiveSessions = async (): Promise<ActiveSessionsSummary> => {
  try {
    const docs = await getCollection<any>(
      'active_sessions',
      undefined,
      undefined,
      undefined,
      5000
    );

    const now = new Date();
    const cutoff = new Date(now.getTime() - SESSION_TIMEOUT_HOURS * 60 * 60 * 1000);

    const sessions: ActiveSession[] = docs
      .map((d: any) => ({
        id: d.id || '',
        userId: d.userId ?? d.user_id ?? d.id ?? '',
        sessionId: d.sessionId ?? d.session_id,
        lastActivityAt: d.lastActivityAt
          ? convertTimestamp(d.lastActivityAt)
          : d.last_activity_at
            ? convertTimestamp(d.last_activity_at)
            : undefined,
        createdAt: d.createdAt ? convertTimestamp(d.createdAt) : d.created_at ? convertTimestamp(d.created_at) : undefined,
        deviceInfo: d.deviceInfo ?? d.device_info ?? (d.platform ? { platform: d.platform } : undefined),
        isActive: d.isActive ?? d.is_active,
      }))
      .filter((s: ActiveSession) => {
        if (s.isActive === false) return false;
        if (s.lastActivityAt && s.lastActivityAt < cutoff) return false;
        return true;
      });

    sessions.sort((a, b) => {
      const ta = a.lastActivityAt?.getTime() ?? 0;
      const tb = b.lastActivityAt?.getTime() ?? 0;
      return tb - ta;
    });

    return {
      totalActiveSessions: sessions.length,
      sessions,
    };
  } catch (error) {
    console.error('Error fetching active sessions:', error);
    return { totalActiveSessions: 0, sessions: [] };
  }
};
